// ------------------------------------------------------------------
// PURE MODULE: vinn_location.mod.js
// ------------------------------------------------------------------
// 1. Explicit Imports (Vite & Efficiency friendly)
import gsap from "gsap"; // Changed to default import for safety
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import "./vinn_location.css";

// 2. Register Dependencies internally
gsap.registerPlugin(DrawSVGPlugin);

export function VinnLocation() {
   ///////////////////////// MAIN MODULE LOGIC START /////////////////////////
    
    const config = {
       BgEl: "progress-line-bg",
       direction: {
        lineProgress: 1
      },
    };

    // Grab DOM elements
    var locsvg = document.getElementById('locsvg');
    var locsvgall = document.getElementById('locsvgall');
	
	const ball02 = document.querySelector(".ball02");
	const ball03 = document.querySelector(".ball03");
	const ball04 = document.querySelector(".ball04");
	const ball05 = document.querySelector(".ball05");


    // Initial Set
    if (locsvgall) gsap.set(locsvgall, { autoAlpha: 0 }); 

    // Define Timeline
    var locatianim = gsap.timeline({ duration: 8 });
    
    // Build Timeline
    if (locsvg && locsvgall) {
        locatianim
            .set(locsvg, { drawSVG: 0 }, 0) 
            .to(locsvgall, 1, { autoAlpha: 1 }, 2) 
            .fromTo(locsvg, 1, { drawSVG: 0 }, { drawSVG: "50%" }, 3)
            .fromTo(locsvg, 1, { drawSVG: "50%" }, { drawSVG: "86%" }, 4)
            .fromTo(locsvg, 1, { drawSVG: "86%" }, { drawSVG: "100%" }, 5)
            .to(locsvgall, 1, { autoAlpha: 0 }, 6)
            .to({}, 1, {}, 7) 
            .to(ball02, 1, { autoAlpha: 1, scale: 3, transformOrigin: 'center', ease: "elastic(2.5, 0.5)" }, 2)
            .to(ball02, 1, { scale: 1, transformOrigin: 'center' }, 3)
            .to(ball03, 1, { autoAlpha: 1, scale: 3, transformOrigin: 'center', ease: "elastic(2.5, 0.5)" }, 3)
            .to(ball03, 1, { scale: 1, transformOrigin: 'center' }, 4)
            .to(ball04, 1, { autoAlpha: 1, scale: 3, transformOrigin: 'center', ease: "elastic(2.5, 0.5)" }, 4)
            .to(ball04, 1, { scale: 1, transformOrigin: 'center' }, 5)
            .to(ball05, 1, { autoAlpha: 1, scale: 3, transformOrigin: 'center', ease: "elastic(2.5, 0.5)" }, 5)
            .to(ball05, 1, { scale: 1, transformOrigin: 'center' }, 6);
    }

    locatianim.pause();
      
    // Update Function
	function updateLineProgress(progressValue) {
   let linePercent = (progressValue % 1 + 1) % 1; 
   if (config.direction.lineProgress === -1) {
   linePercent = 1 - linePercent;
   }
   locatianim.progress(linePercent);
}


    ///////////////////////// MAIN MODULE LOGIC END /////////////////////////

    // Return the Interface
    return { config, updateLineProgress };
}